// Guided spotlight tour for the Sidebar.
// Highlights each sidebar section to orient new users.

import { SIDEBAR_TOUR_STEPS, markSidebarTourCompleted } from './tourSteps'
import { SpotlightTour } from './SpotlightTour'

export function SidebarTour({ onClose }: { onClose: () => void }) {
  const handleClose = () => {
    markSidebarTourCompleted()
    onClose()
  }

  return <SpotlightTour steps={SIDEBAR_TOUR_STEPS} onClose={handleClose} />
}
